import { Component, AfterViewInit, ElementRef, ViewChild, OnChanges, Output, EventEmitter, inject, Input } from '@angular/core';
import Map from 'ol/Map';
import View from 'ol/View';
import TileLayer from 'ol/layer/Tile';
import OSM from 'ol/source/OSM';
import WebGLVectorLayer from 'ol/layer/WebGLVector';
import VectorSource from 'ol/source/Vector';
import Draw from 'ol/interaction/Draw';
import Modify from 'ol/interaction/Modify';
import Snap from 'ol/interaction/Snap';
import GeoJSON from 'ol/format/GeoJSON';

import { fromLonLat } from 'ol/proj';
import { ActivatedRoute } from '@angular/router';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-parking-map',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './parking-map.component.html',
  styleUrl: './parking-map.component.scss'
})
export class ParkingMapComponent implements AfterViewInit {

 @Input() geojson: any;
 @Input() readonly = false;

  @ViewChild('mapContainer', { static: false }) mapContainer!: ElementRef<HTMLDivElement>;
  @Output() coordinatesChange = new EventEmitter<any>();

  private pendingGeoJSON: any = null;

  map!: Map;
  vectorSource!: VectorSource;
  mapValidationError:boolean = false;
  private _hasFitted: any;
  constructor(private routes:ActivatedRoute){
  }

  ngOnChanges() {
    if (this.geojson) {
      this.setDrawnCoordinatesFromGeoJSON(this.geojson);
    }
  }

  ngAfterViewInit(): void {
    const styleVariables = {
      width: 2,
      offset: 0,
      capType: 'butt',
      joinType: 'miter',
      miterLimit: 10
    };

    const style = {
      'stroke-width': ['var', 'width'],
      'stroke-color': 'rgba(0, 153, 255, 1)',
      'stroke-offset': ['var', 'offset'],
      'stroke-miter-limit': ['var', 'miterLimit'],
      'stroke-line-cap': ['var', 'capType'],
      'stroke-line-join': ['var', 'joinType'],
    };

    this.vectorSource = new VectorSource();

    this.vectorSource.on('addfeature', () => this.emitCoordinates());
    this.vectorSource.on('removefeature', () => this.emitCoordinates());
    this.vectorSource.on('changefeature', () => this.emitCoordinates());
    this.vectorSource.on('change', () => this.emitCoordinates());


    const webglVectorLayer = new WebGLVectorLayer({
      source: this.vectorSource,
      style,
      variables: { ...styleVariables }
    });


    this.map = new Map({
      target: this.mapContainer.nativeElement,
      layers: [
        new TileLayer({
          source: new OSM()
        }),
        webglVectorLayer
      ],
      view: new View({
        center: fromLonLat([12.5674, 41.8719]), // deafult location (Italy)
        zoom: 6
      })
    });

    if (!this.readonly) {
      const modify = new Modify({ source: this.vectorSource });
      this.map.addInteraction(modify);

      const draw = new Draw({
        source: this.vectorSource,
        type: 'LineString',
      });

      const updateDrawState = () => {
        const hasFeature = this.vectorSource.getFeatures().length > 0;
        draw.setActive(!hasFeature); // if map has more the on features inside [] it will disable draw line
      };

      this.vectorSource.on('addfeature', updateDrawState);
      this.vectorSource.on('removefeature', updateDrawState);

      updateDrawState();

      this.map.addInteraction(draw);

      const snap = new Snap({ source: this.vectorSource });
      this.map.addInteraction(snap);
    }


    if (this.pendingGeoJSON) {
      this.setDrawnCoordinatesFromGeoJSON(this.pendingGeoJSON);
      this.pendingGeoJSON = null;
    }

  }

  emitCoordinates() {
    const geojson = new GeoJSON();
    const json = geojson.writeFeaturesObject(this.vectorSource.getFeatures());
    this.coordinatesChange.emit(json);
  }

  getDrawnCoordinatesAsGeoJSON(): any {
    const geojson = new GeoJSON();
    const json =  geojson.writeFeaturesObject(this.vectorSource.getFeatures());

    return json;
  }

   setDrawnCoordinatesFromGeoJSON(geojsonObject: any) {
    if(!geojsonObject){
      return ;
    }
    if (!this.map || !this.vectorSource) {
      this.pendingGeoJSON = geojsonObject;
      return;
    }
    const geojson = new GeoJSON();
    const features = geojson.readFeatures(geojsonObject, {
      dataProjection: 'EPSG:3857',
      featureProjection: this.map.getView().getProjection()
    });
    this.vectorSource.clear();
    this.vectorSource.addFeatures(features);

    if (features.length > 0) {
      const extent = this.vectorSource.getExtent();
      if (extent && extent.some(Number.isFinite)) {
        if (!this._hasFitted) {
          this.map.getView().fit(extent, {
          padding: [40, 40, 40, 40],
          maxZoom: 18,
          duration: 0
          });
          this._hasFitted = true;
        }
      }
    }

  }

  clearMap(): void {
    this.pendingGeoJSON  = null;
    this.vectorSource.clear();
  }


}
